import { URL } from '../constants';
import { apiLoaderInstance } from '../instance';

import { CreateHospitalServiceRequest } from './types';

export const createHospitalService = (data: CreateHospitalServiceRequest) =>
  apiLoaderInstance.post(URL.GET_HOSPITAL_SERVICES_LIST, data);
